import { DSReceptionProductDTO } from "./Shop/DirectSuppliers/SupplierReception/ProductConfirmation/ProductConfirmation"
import { UnorderedProductForm } from "./Shop/DirectSuppliers/SupplierReception/GoodsValidation/serializers";

export const validateScanCode = (
  showNotification: Function,
  scanCode: string,
  codeType: string,
  message = ''
) => {
  if (!/^[A-Za-z0-9]+$/.test(scanCode)) {
    showNotification({
      message: message || `Cod invalid pentru ${codeType}.`,
      type: 'error'
    })
    return false
  }
  return true
}

export const getReturoMaterialLabel = (materialType: 'VAT' | 'SACK' | string): string => {
  switch (materialType) {
    case 'VAT':
      return 'Tip cuvă'
    case 'SACK':
      return 'Tip sac'
    default:
      return ''
  }
}

export const getReturoScanLabel = (scanType: 'INVENTORY' | 'DELIVERY' | string): string => {
  switch (scanType) {
    case 'INVENTORY':
      return 'Tip inventariere'
    case 'DELIVERY':
      return 'Tip predare'
    default:
      return ''
  }
}

export const getReturoId = (shops) => {
  if (shops) {
    const selectedStoreCode = localStorage.getItem('selectedStoreCode')
    if (shops.length > 1 && selectedStoreCode) {
      const selectedShop = shops.find(shop => shop.value === selectedStoreCode)
      return selectedShop?.idReturo ?? ''
    }

    return shops[0]?.idReturo ?? ''
  }
}

export const displayOrDash = (v: any) =>
  typeof v === 'number' ? String(v) : (v?.toString().trim() || '-')

export const toNumberOrNull = (v: string | number | null | undefined): number | null => {
  if (v === '' || v === null || v === undefined) return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

export const normalizeProductCodeInput = (value: string) => {
  return value.replace(/\D/g, '').slice(0, 13)
}

export const isAdditionalItem = (r: DSReceptionProductDTO) => !r.orderLineNumber

export const isEmptyProductResponse = (data: any): boolean => {
  if (data === null) return true
  if (typeof data !== 'object') return false
  return Object.keys(data).length === 0
}

export const isUnorderedScanResponse = (data: any): boolean => {
  if (isEmptyProductResponse(data)) return true
  if (typeof data !== 'object') return false

  return (
    (data.orderLineNumber === null || data.orderLineNumber === undefined || data.orderLineNumber === 0) &&
    data.articleCode === null &&
    data.eanCode === null &&
    data.articleName === null
  )
}

export const getEmptyUnorderedForm = (): UnorderedProductForm => ({
  scannedCode: '',
  measureUnit: '',
  receivedQuantity: '',
  unitsPerLogisticUnit: '',
  pcbNumber: '',
  articleName: '',
  expirationDate: ''
})
